// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateSearchDivisionParam = value => ({
    type: actions.UPDATE_DEALER_SEARCH_DIVISION_PARAMS,
    value
});



// WEBPACK FOOTER //
// ./src/product/dealer-search/action-creators/update-search-division-param.js